export default __webpack_public_path__ + "static/media/botanical.ecf7d89f.jpg";